import { CustomerCard } from './CustomerCard';
import { TtCallNote } from './TtCallNote';
import { Icon } from './Icon';

/**
 * UGYFEL-PANEL a hivas ablakaban - a chat mellett, a jobb oldalon.
 *
 * ─── Miert oldalpanel, es nem a resztvevok folott? ──────────────────────────
 *
 * Mert a beszelgetes KOZBEN kell: a kolléga egyszerre nezi, ki hiv, mi all az
 * ugyfel jegyzeteiben, es gépeli, amit megbeszelnek. A resztvevok folott allo
 * kartya ehhez tul keskeny, es minden uj sorral lejjebb tolna a kepeket.
 *
 * A csengeteskor latott kartya SZANDEKOSAN maradt a helyen: ott meg egyetlen
 * dontes van (felveszem vagy nem), es ahhoz elég egy rovid kartya.
 *
 * ─── Miert lehet KOZBEN jegyzetelni? ────────────────────────────────────────
 *
 * Mert akkor tudja a kolléga, mit beszeltek meg - nem tiz perccel kesobb. A
 * gepelt szoveg piszkozatkent helyben megmarad (bongeszo-tarolo), es a hivas
 * utan ugyanott folytathato: a panel nem vagja felul azzal, amit a szerver
 * kesobb kuld.
 */
export function CustomerPanel({
  huddleId,
  number,
  live,
  onClose,
}: {
  huddleId: string;
  number: string | null;
  /** Tart-e meg a hivas. Ettol fugg, hogy az atirat teljes-e. */
  live: boolean;
  onClose: () => void;
}) {
  return (
    <aside className="flex shrink-0 flex-col max-sm:absolute max-sm:inset-0 max-sm:z-30 max-sm:bg-surface-raised border-l border-border-soft bg-surface-raised sm:w-96">
      <header className="flex items-center gap-2 border-b border-border-soft px-3 py-2">
        <Icon name="cimjegyzek" size="sm" className="text-ink-faint" />
        <p className="min-w-0 flex-1 truncate text-xs font-semibold">Ügyfél</p>
        <button
          type="button"
          onClick={onClose}
          aria-label="Ügyfélpanel bezárása"
          className="rounded-control px-1.5 py-1 text-ink-faint transition-colors hover:bg-surface-hover hover:text-ink"
        >
          <Icon name="bezaras" size="sm" />
        </button>
      </header>

      <div className="min-h-0 flex-1 space-y-3 overflow-y-auto px-3 py-2.5">
        {number ? (
          <>
            {/*
              Itt MAR lehet ugyfelhez kotni a szamot: a kolléga felvette, es
              elhangzott, ki hiv. (Csengeteskor ez tiltott - lasd CustomerCard.)
            */}
            <CustomerCard number={number} assignable />
            <TtCallNote huddleId={huddleId} number={number} live={live} embedded />
          </>
        ) : (
          <p className="text-2xs text-ink-faint">Ehhez az öleléshez nem tartozik telefonszám.</p>
        )}
      </div>
    </aside>
  );
}
